import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import MinusIcon from '../../../public/static/icons/minus.svg';
import PlusIcon from '../../../public/static/icons/plus-gifts.svg';
import FormattedText from '../../../components/01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../utils/behaviorSettings';
import DefaultPicture from '../../../components/01_atoms/DefaultPicture';
import { propTypes as PicturePropTypes } from '../../../components/01_atoms/DefaultPicture';

import styles from './index.module.scss';

const BBFAQWithImage = ({
  items,
  image,
  heading = '',
  style = 'default',
  behaviorSettings = null,
}) => {
  const classes = [
    'bb',
    styles['bb-faq-with-image'],
    styles[`bb-faq-with-image--${style}`],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')}>
      <div className="container">
        <div className={styles['bb-faq-with-image__background']}>
          <div className={styles['bb-faq-with-image__left']}>
            <h3
              className={styles['bb-faq-with-image__heading']}
              dangerouslySetInnerHTML={{ __html: heading }}
            />
            <div className={styles['bb-faq-with-image__image']}>
              {image && <DefaultPicture {...image} />}
              {!image && (
                <picture>
                  <img
                    src={'/static/Gifts/images/faq-santa-default.webp'}
                    alt={heading.replace(/(<([^>]+)>)/gi, '')}
                    width={388}
                    height={374}
                  />
                </picture>
              )}
            </div>
          </div>
          <div className={styles['bb-faq-with-image__right']}>
            <Accordion
              className={styles['bb-faq-with-image__items']}
              allowMultipleExpanded={true}
              allowZeroExpanded={true}
              preExpanded={['first-item']}
            >
              {items.map((item, index) => (
                <AccordionItem
                  key={item.title}
                  className={styles['bb-faq-with-image__item']}
                  uuid={index === 0 ? 'first-item' : null}
                >
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={styles['bb-faq-with-image__item-button']}
                      data-component="faq-with-image-item"
                    >
                      <div>{item.title}</div>
                      <AccordionItemState>
                        {(state) =>
                          state.expanded ? (
                            <MinusIcon className={styles['bb-faq-with-image__item-icon']} />
                          ) : (
                            <PlusIcon className={styles['bb-faq-with-image__item-icon']} />
                          )
                        }
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel className={styles['bb-faq-with-image__item-description']}>
                    <FormattedText text={item.description} />
                  </AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
          <div className={styles['bb-faq-with-image__bottom-image']}>
            <DefaultPicture {...image} />
          </div>
        </div>
      </div>
    </div>
  );
};

BBFAQWithImage.propTypes = {
  items: PropTypes.array.isRequired,
  heading: PropTypes.string,
  style: PropTypes.oneOf(['default', 'christmas']),
  image: PropTypes.shape(PicturePropTypes),
  behaviorSettings: behaviorSettingsProps,
};

export default BBFAQWithImage;
